module.exports = __webpack_public_path__ + "static/img/down.e297a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/down.png
// module id = rix4
// module chunks = 1